// hooks/usePageTitle.ts — hand-rolled document.title setter (no react-helmet dependency,
// matching this repo's "fully-custom, no heavy deps" convention — see e.g.
// feedback/lib/markdown.tsx's own no-deps rationale).
//
// Sets document.title to the FULL string the caller passes (each page composes its own
// exact title — the format differs per page: "Explore / TruXSocial", "«Name» (@handle) on
// TruXSocial", "Support TruXSocial", etc.) and restores the app-wide default "TruXSocial"
// on unmount, so navigating away never leaves a stale title behind for the next page to
// silently inherit. Pass null/empty for a page that carries no per-page title (Home) —
// it renders the bare default.

import { useEffect } from 'react';

export const DEFAULT_PAGE_TITLE = 'TruXSocial';

export function usePageTitle(title: string | null): void {
  useEffect(() => {
    document.title = title || DEFAULT_PAGE_TITLE;
    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [title]);
}
